import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

interface UseSmoothNavigationProps {
  bucketName?: string;
  s3Service: {
    listObjects: (prefix?: string) => Promise<void>;
  };
}

export const useSmoothNavigation = ({ bucketName, s3Service }: UseSmoothNavigationProps) => {
  const history = useHistory();
  const [isNavigating, setIsNavigating] = useState(false);

  const navigateToDirectory = useCallback(
    async (directoryPath: string) => {
      if (!bucketName) return;

      try {
        setIsNavigating(true);

        // Normalize directory path with trailing slash
        const prefix = directoryPath || undefined;

        // Load directory contents
        await s3Service.listObjects(prefix);

        // Navigate to new URL
        const newUrl = directoryPath ? `/drive/${bucketName}/${directoryPath}` : `/drive/${bucketName}`;
        history.push(newUrl);
      } catch (error) {
        console.error('Navigation failed:', error);
      } finally {
        setIsNavigating(false);
      }
    },
    [bucketName, s3Service, history]
  );

  return {
    navigateToDirectory,
    isNavigating,
  };
};
